export default [
  // *===================Tax Setup List============================---*

  {
    path: "/journalentry/list",
    name: "journalentry-list",
    component: () =>
      import(
        "@/views/accounting/journalentry/journalentry-list/JournalEntry.vue"
      ),
    meta: {
      pageTitle: "Journal Entry List",
      breadcrumb: [
        {
          text: "Journal Entry List",
          active: true,
        },
      ],
      //permission: 'Permissions.Accounting.View'
    },
  },
  {
    path: "/journalentry/add",
    name: "journalentry-add",
    component: () =>
      import("@/views/accounting/journalentry/AddJournalEntry.vue"),
    meta: {
      pageTitle: "Journal Entry List",
      breadcrumb: [
        {
          text: "Journal Entry List",
          to: "/journalentry/list",
        },
        {
          text: "Add Journal Entry",
          active: true,
        },
      ],
      //permission: 'Permissions.Accounting.View'
    },
  },
  {
    path: "/journalentry/view/:id",
    name: "journalentry-view",
    component: () => import("@/views/accounting/journalentry/ViewJournalEntry.vue"),
    meta: {
      pageTitle: "View Journal Entry",
      breadcrumb: [
        {
          text: "Journal Entry List",
          to: "/journalentry/list",
        },
        {
          text: "View Journal Entry",
          active: true,
        },
      ],
      //permission: 'Permissions.Accounting.View'
    },
  },
  {
    path: "/journalentry/edit/:id",
    name: "journalentry-edit",
    component: () => import("@/views/accounting/journalentry/EditJournalEntry.vue"),
    meta: {
      pageTitle: "Edit Journal Entry",
      breadcrumb: [
        {
          text: "Journal Entry List",
          to: "/journalentry/list",
        },
        {
          text: "Edit Journal Entry",
          active: true,
        },
      ],
      //permission: 'Permissions.Accounting.View'
    },
  },
];
